
























































import Vue from 'vue'
import { recommendedProductsQuery } from '@/product/queries'
import { apolloClient } from '@/common/service/apolloClient'
import { SYSTEM_ERROR } from '@/common/const'
import { getSimilarProducts_similarProducts_items as ProductType } from '@/product/types/getSimilarProducts'
import { BQ_EVENT_NAMES, BQ_AWS_PERSONALIZE_AREA_NAME, raksulBQEventTracker } from '@/common/utils/eventTracker'
import { checkCache } from '@/product/utils'
import LocalStorageSerializer from '@/common/localStorageSerializer'
import { LOCAL_STORAGE_FAVORITE_PRODUCTS } from '@/editor/config/tutorial'
//@ts-ignore
import Swiper from 'swiper/dist/js/swiper.min.js'
import CarouselProductCard from '@/common/components/carouselProducts/CarouselProductCard.vue'
import FavoriteBtnPopup from '@/common/components/FavoriteBtnPopup.vue'

const MOBILE_BREAKPOINT = 768

export default Vue.extend({
  components:{
    CarouselProductCard,
    FavoriteBtnPopup
  },
  props: {
    pattern: {
      type: String,
      required: true
    },
    pageType: {
      type: String,
      required: true
    },
    pageArea: {
      type: String,
      required: true
    },
    trackingPageType: {
      type: String,
      required: true
    },
    trackingRecommendationLogic: {
      type: String,
      required: true
    },
    productId: {
      type: Number,
      required: false,
      default: null
    },
    hasFourItems: {
      type: Boolean,
      required: false,
      default: false
    },
    sectionTitle: {
      type: String,
      required: true
    }
  },
  data(): {
    productList: Array<ProductType>,
    itemOffset: number,
    itemLimit: number,
    itemTotalCount: number,
    itemPage: number,
    slideClass: string
    swiper: any,
    hasUpdate: boolean
  } {
    return {
      productList: [],
      itemOffset: 0,
      itemLimit: 5,
      itemTotalCount: 0,
      itemPage: 1,
      slideClass: 'slide-out',
      swiper: undefined,
      hasUpdate: false
    }
  },
  computed: {
    disablePrev(): boolean {
      return this.itemPage == 1
    },
    disableNext(): boolean {
      return this.itemPage == this.itemTotalPage
    },
    itemTotalPage(): number{
      return this.itemTotalCount < this.itemLimit ? 1 : Math.ceil(this.itemTotalCount / this.itemLimit)
    },
    isMobileView(): boolean {
      return window.innerWidth <= MOBILE_BREAKPOINT
    }
  },
  updated() {
      if (this.isMobileView && !this.hasUpdate) {
        this.swiper = new Swiper('.sw-Carousel_Wrapper', {
          spaceBetween: 24,
          pagination: false,
          slidesPerView: 1.5,
          loop: true,
          lazy: {
            loadPrevNext: false
          }
        })

        this.hasUpdate = true
      }
  },
  created() {
    if (this.hasFourItems) {
      this.itemLimit = 4
    }
  },
  mounted() {
    this.returnProducts()
    LocalStorageSerializer.remove(LOCAL_STORAGE_FAVORITE_PRODUCTS)
  },
  methods: {
    nextPage(pageIndex: number, itemClass: string) {
      if (pageIndex === this.itemTotalPage) this.itemPage = 1
      else this.itemPage = pageIndex + 1
      this.slideClass = itemClass
      this.returnProducts()
    },
    prevPage(pageIndex: number, itemClass: string) {
      if (pageIndex === 1) this.itemPage = this.itemTotalPage
      else this.itemPage = pageIndex - 1
      this.slideClass = itemClass
      this.returnProducts()
    },
    async returnProducts() {
      this.itemOffset = 0
      if (this.itemPage != 1) {
        this.itemOffset = (this.itemPage * this.itemLimit) - this.itemLimit
      }

      let awsPersonalize = {
        numResults: 16,
        pattern: this.pattern,
        pageType: this.pageType,
        pageArea: this.pageArea
      }

      if (this.productId) {
        awsPersonalize.productId = this.productId
      }
      await apolloClient
        .query({
          query: recommendedProductsQuery,
          variables: {
            offset: this.isMobileView ? 0 : this.itemOffset,
            limit: this.isMobileView ? 16 : this.itemLimit,
            awsPersonalize: awsPersonalize
          }
        })
        .then(response => {
          this.itemTotalCount = response.data?.recommendedProducts.totalItemsCount
          this.productList = checkCache(response.data?.recommendedProducts.items)
        })
        .catch(error => {
          if (error?.response?.status) {
             alert(error || SYSTEM_ERROR.UNKNOWN)
          }
        })
    },
    productPagePath(similarProductId: string): string {
      return `/products/${similarProductId}`
    },
    onClickProduct(productId: string) {
      raksulBQEventTracker({
          eventName: BQ_EVENT_NAMES.CLICK_AWS_PERSONALIZE,
          data: {
            productId: productId,
            recommendationLogic: this.trackingRecommendationLogic,
            pageType: this.trackingPageType,
            areaName: BQ_AWS_PERSONALIZE_AREA_NAME.ABOVE_FOOTER
          }
        })
      location.href = this.productPagePath(productId)
    }
  }
})
